import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import ModalComponent from "../../components/modals";
import LaddaButton from "../../components/buttons/laddaButton";
import { months } from "../../constants/selectData";

const getCurrentYear = () => new Date().getFullYear();
const getCurrentMonth = () => new Date().getMonth() + 1;

const DownloadTaskMonthlyModal = ({
  open,
  handleClose,
  yearOptions = [],
  defaultYear,
  defaultMonth,
  onConfirm,
  loading = false
}) => {
  const fallbackYear = defaultYear || getCurrentYear();
  const fallbackMonth = defaultMonth || getCurrentMonth();
  const [year, setYear] = useState(fallbackYear);
  const [month, setMonth] = useState(fallbackMonth);

  useEffect(() => {
    if (!open) return;
    setYear(defaultYear || fallbackYear);
    setMonth(defaultMonth || fallbackMonth);
  }, [open, defaultYear, defaultMonth, fallbackYear, fallbackMonth]);

  const yearsToRender =
    Array.isArray(yearOptions) && yearOptions.length > 0
      ? yearOptions
      : [{ name: String(fallbackYear), value: fallbackYear }];

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      title="Descargar tareas por mes"
      width="520px"
      actions={
        <>
          <LaddaButton
            color="6A6AD8"
            backgroundColor={"white"}
            onClick={handleClose}
            disabled={loading}
          >
            <div className="HContainer align-center">
              <p className="button_text">Cancelar</p>
            </div>
          </LaddaButton>
          <LaddaButton
            variant="contained"
            onClick={() => onConfirm?.({ year, month })}
            loading={loading}
            disabled={loading || !year || !month}
          >
            <div className="HContainer align-center">
              <p className="button_text">
                {loading ? "Descargando..." : "Descargar Excel"}
              </p>
            </div>
          </LaddaButton>
        </>
      }
    >
      <Box display="flex" flexDirection="column" gap={2} pt={1}>
        <Typography variant="body2" color="text.secondary">
          Selecciona el año y el mes para descargar el consolidado de tareas.
        </Typography>

        <Box
          display="grid"
          gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }}
          gap={2}
        >
          <FormControl fullWidth size="small">
            <InputLabel id="task-download-year-label">Año</InputLabel>
            <Select
              labelId="task-download-year-label"
              value={year}
              label="Año"
              onChange={(event) => setYear(event.target.value)}
            >
              {yearsToRender.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel id="task-download-month-label">Mes</InputLabel>
            <Select
              labelId="task-download-month-label"
              value={month}
              label="Mes"
              onChange={(event) => setMonth(event.target.value)}
            >
              {months.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </ModalComponent>
  );
};

export default DownloadTaskMonthlyModal;
